import rotaryAreas from '@milora/data/rotary-focus-areas.json';

export type RotaryFocusAreaDefinition = {
  id: string;
  title: string;
  description: string;
};

export const ROTARY_FOCUS_AREAS = rotaryAreas as RotaryFocusAreaDefinition[];

export function getRotaryDefinitionById(id: string): RotaryFocusAreaDefinition | undefined {
  return ROTARY_FOCUS_AREAS.find((a) => a.id === id);
}
